<sh-form-tag-list
    *ngIf="profileField$ | async as profileField"
    [id]="profileField.FieldDefinition.FlatKey"
    [control]="control$ | async"
    [label]="profileField.DisplayLabel"
    [labelIcons]="labelIcons"
    [helpText]="profileField.Description"
    [placeholder]=""
    [duplicateErrorMsg]=""
    [errorMsg]="(errorMsg$ | async) || '' | translate"
    [canBeIndeterminate]="canBeIndeterminate"
    [indeterminateMsg]="'general.only-matching-values-shown' | translate"
    [caseSensitive]="false"
    [autocompleteFct]="autocompleteFunction"
    [title]="disabledMessageKey | translate"
    (duplicateValues)="receiveDuplicatesEmitted($event)"
>
    <ng-content></ng-content>
</sh-form-tag-list>

<div class="sh-form-group" *ngIf="visibleDuplicates.length > 0">
    <label for="input-field-5" class="sh-form-group__label">
        <em class="sh-form-group__label__em"> </em>
        {{ "form.keywords.duplicates" | translate }}
    </label>
    <med-tag-suggestions [tags]="visibleDuplicates" (tagAccepted)="duplicateAccepted($event)" (tagDeclined)="duplicateDeclined($event)"></med-tag-suggestions>
</div>

<ng-container *ngIf="control$ | async as control">
    <div class="sh-form-group" *ngIf="suggestionsEnabled && !control.disabled">
        <label for="input-field-5" class="sh-form-group__label">
            <em class="sh-form-group__label__em"> </em>
            {{ "form.suggestions.keyword-ai.ai-suggestions" | translate }}
        </label>
        <med-tag-suggestions
            [tags]="visibleSuggestions"
            (tagAccepted)="tagAccepted($event)"
            (tagDeclined)="tagDeclined($event)"
            [noTagsMessage]="'form.suggestions.keyword-ai.no-suggestions' | translate"
        ></med-tag-suggestions>
    </div>
</ng-container>
